export default "__VITE_ASSET__CJm8_r_A__"